/**
 * UnderservedDemographicsChart — NOT_CONNECTED
 *
 * Demographics data requires Survey Data integration.
 */
import React from 'react';
import DataSourceNotConnected from './DataSourceNotConnected';
import { NOT_CONNECTED_REGISTRY } from '../../../types/insightsTypes';

const UnderservedDemographicsChart: React.FC = () => {
  return (
    <DataSourceNotConnected
      info={NOT_CONNECTED_REGISTRY.survey}
      metricName="Underserved Demographics Performance"
    />
  );
};

export default UnderservedDemographicsChart;